export abstract class PatternConstants {
    static readonly email: RegExp = /[\w.%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/;
    static readonly username: RegExp = /^[\w@.-]+$/;
    static readonly password: RegExp = /^(?=.*[\d])(?=.*[a-z])(?=.*[A-Z])\S{8,4096}$/;
}
